import { defineStore } from "pinia";
import { useUserStore } from "./UserStore";

export const useTrackAnalyticsStore = defineStore("TrackAnalyticsStore", {
  state: () => ({}),
  getters: {},
  actions: {
    async saveTrackAnalytics(params) {
      let userStore = useUserStore();

      params.user_id = userStore.$state.user_id ?? "";
      params.customer_id = userStore.$state.customer_id ?? "";

      const nuxtApp = useNuxtApp();
      const route = nuxtApp._route;
      const pathModule = params.path_module ?? route?.meta?.module ?? "";
      const pathName = route?.fullPath ?? "";
      const pathParams = route?.params ? JSON.stringify(route.params) : "";

      Object.assign(params, {
        path_module: pathModule,
        path_name: pathName,
        path_params: pathParams,
      });

      try {
        const res = await $fetch("/api/others/save-track-analytics", {
          method: "POST",
          body: params,
        });
        return res;
      } catch (error) {
        console.error("API error:", error);
        return null;
      }
    },
  },
});
